import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgHydroquinoneGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m33.08 11.24-16-1.24L8 23.24l6.93 14.48 16.01 1.24 9.08-13.24-6.94-14.48Zm-2.77 26.42-14.56-1.13-6.31-13.18L17.7 11.3l14.57 1.13 6.31 13.18-8.27 12.05Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "m23.31 23.58-1.18-2.41 2.43-1.18 1.18 2.41 1.11-.55-2.77-5.66-1.11.54 1.08 2.21-2.43 1.19-1.08-2.21-1.11.54 2.78 5.66 1.1-.54ZM28.39 16.02l.43 2.9.09.4-.25-.32-2.03-2.12-1.14.55 3.44 3.34.25 2.09 1.09-.53-.74-6.87-1.14.56ZM16.52 24.14c-1.23 0-2.23 1-2.23 2.23s1 2.23 2.23 2.23 2.23-1 2.23-2.23-1-2.23-2.23-2.23Zm0 3.21c-.54 0-.98-.44-.98-.98s.44-.98.98-.98.98.44.98.98-.44.98-.98.98ZM24.95 27.49c-1.7 0-3.09 1.39-3.09 3.09s1.39 3.09 3.09 3.09 3.09-1.39 3.09-3.09-1.38-3.09-3.09-3.09Zm0 4.92c-1.01 0-1.84-.82-1.84-1.84 0-1.01.83-1.84 1.84-1.84 1.01 0 1.84.82 1.84 1.84s-.82 1.84-1.84 1.84Z",
    fill: "currentColor"
  }));
}

export { SvgHydroquinoneGlyph as default };
